import { APIRedirect } from '@/types'

export function isAPIRedirect(obj: unknown): obj is APIRedirect {
    return obj !== null && typeof obj === 'object' && 'redirectTarget' in obj && 'status' in obj
}
